import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';

export interface CopyConfirmationData {
  tripName: string;
  expenseCount: number;
  totalAmount: number;
  category: string;
}

@Component({
  selector: 'app-copy-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatTableModule],
  template: `
    <h2 mat-dialog-title>Copy to Family Expenses?</h2>
    <mat-dialog-content>
      <table class="summary-table">
        <tr>
          <td class="label">Trip Name:</td>
          <td class="value">{{ data.tripName }}</td>
        </tr>
        <tr>
          <td class="label">Expenses to Copy:</td>
          <td class="value">{{ data.expenseCount }}</td>
        </tr>
        <tr>
          <td class="label">Your Total Share:</td>
          <td class="value">₹{{ data.totalAmount.toFixed(2) }}</td>
        </tr>
        <tr>
          <td class="label">Category:</td>
          <td class="value">{{ data.category }}</td>
        </tr>
      </table>
      <p class="confirm-text">Do you want to proceed?</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">Cancel</button>
      <button mat-flat-button color="primary" [mat-dialog-close]="true">Confirm</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .summary-table {
      width: 100%;
      border-collapse: collapse;
      margin: 16px 0;
    }
    
    .summary-table td {
      padding: 12px 8px;
      border-bottom: 1px solid #e0e0e0;
    }
    
    .summary-table tr:last-child td {
      border-bottom: none;
    }
    
    .label {
      font-weight: 500;
      color: #666;
      font-weight: 500;
      color: #666;
      width: 40%;
      padding-right: 8px;
    }
    
    .value {
      font-weight: 600;
      color: #333;
      font-weight: 600;
      color: #333;
      text-align: right;
      word-break: break-word;
      overflow-wrap: break-word;
    }
    
    .confirm-text {
      margin-top: 16px;
      font-weight: 500;
      color: #555;
    }
    
    mat-dialog-content {
      width: 100%;
      box-sizing: border-box;
      overflow-x: hidden;
    }
  `]
})
export class CopyConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CopyConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CopyConfirmationData
  ) { }
}
